"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.UP = exports.NEUTRAL = exports.DOWN = exports.DIRECTIONS = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _emailUtils = require("../../../../utils/emailUtils");
var _userflow = _interopRequireDefault(require("../../../../styles/userflow"));
var UP = exports.UP = 'up';
var DOWN = exports.DOWN = 'down';
var NEUTRAL = exports.NEUTRAL = 'neutral';
var DIRECTIONS = exports.DIRECTIONS = [UP, DOWN, NEUTRAL];
var PriceDirection = function PriceDirection(_ref) {
  var direction = _ref.direction,
    iconSize = _ref.iconSize,
    withText = _ref.withText;
  var directions = {};
  directions[UP] = {
    icon: withText ? '▲' : '△',
    bgColor: '#F9EAEC',
    iconColor: '#D0021B',
    text: 'Выросла'
  };
  directions[DOWN] = {
    icon: withText ? '▼' : '▽',
    bgColor: '#F1F7D2',
    iconColor: '#6ABF40',
    text: 'Снизилась'
  };
  var _directions$direction = directions[direction],
    icon = _directions$direction.icon,
    bgColor = _directions$direction.bgColor,
    iconColor = _directions$direction.iconColor,
    text = _directions$direction.text;
  var styles = {
    container: {
      padding: withText ? '4px 8px' : 'inherit',
      marginRight: withText ? '4px' : '0',
      borderRadius: '50px',
      backgroundColor: withText ? bgColor : 'transparent',
      color: _userflow["default"].colors.blackbase,
      fontWeight: 'normal',
      lineHeight: '33px',
      mobile: {
        lineHeight: '27px'
      }
    },
    icon: {
      color: iconColor,
      fontSize: withText ? "".concat(iconSize, "px") : 'inherit',
      paddingLeft: withText ? '3px' : '0'
    }
  };
  var DirectionContainer = (0, _emailUtils.adaptiveStyled)('span', styles.container);
  var DirectionIcon = (0, _emailUtils.adaptiveStyled)('span', styles.icon);
  return /*#__PURE__*/_react["default"].createElement(DirectionContainer, null, withText && text, /*#__PURE__*/_react["default"].createElement(DirectionIcon, null, icon));
};
PriceDirection.defaultProps = {
  iconSize: 18,
  withText: false
};
PriceDirection.propTypes = {
  direction: _propTypes["default"].oneOf(DIRECTIONS).isRequired,
  iconSize: _propTypes["default"].number,
  withText: _propTypes["default"].bool
};
var _default = exports["default"] = PriceDirection;